import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import RegisterForm from "./RegisterForm";
import { registerAccount } from "../../modules";
import { setAppError } from "../../../common";
import strings from "../../../../res/strings";

import styled from "styled-components";
const FormContainer = styled.div`
  background: rgba(255, 255, 255, 0.15);
  height: 100vh;
`;

let RegisterPanel = (props) => {
  const submitRegistration = (values) => {
    if (values.password !== values.confirmPassword) {
      props.setAppError({
        notificationType: "alert",
        context: "lib_authentication._.registerPage",
        message:
          strings.lib_authentication_state_error_registration_confirm_password,
      });
    } else {
      props.registerAccount(
        {
          values,
          successState: (response) => {
            props.setRightPanel("LOGIN");

            return {
              context: "lib_authentication.registerAccount.registerPage",
              notificationType: "alert",
              message:
                "Successfully registered account. Please check your email for instructions on how to activate your account.",
            };
          },
          errorState: (error) => ({
            notificationType: "alert",
            context: "lib_authentication.registerAccount.registerPage",
            ...error,
          }),
        },
        props.history
      );
    }
  };

  return (
    <FormContainer>
      <RegisterForm
        onSubmit={submitRegistration}
        setRightPanel={props.setRightPanel}
      />
    </FormContainer>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      registerAccount,
      setAppError,
    },
    dispatch
  );
RegisterPanel = connect(mapStateToProps, mapDispatchToProps)(RegisterPanel);
export { RegisterPanel };

let RegisterPage = (props) => {
  let history = useHistory();

  useEffect(() => {
    if (props.credentials) {
      history.push(process.env.REACT_APP_DEFAULT_AUTHENTICATED_PATH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>{strings.lib_authentication_title_register}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <RegisterPanel />
      </IonContent>
    </IonPage>
  );
};

export default RegisterPage;
